<router-outlet></router-outlet>
<simple-notifications [options]="options"></simple-notifications>